module.exports = __webpack_public_path__ + "static/media/head-side.6c409d4f.svg";